import { render, staticRenderFns } from "./AddFilter.vue?vue&type=template&id=08370e2e"
import script from "./AddFilter.vue?vue&type=script&lang=js"
export * from "./AddFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports